import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { initializeI18n } from './i18n';
import { installIosKeyboardViewportFix } from './iosKeyboardViewportFix';

import '@fontsource/source-sans-pro/400.css';
import '@fontsource/source-sans-pro/600.css';
import '@fontsource/source-sans-pro/700.css';
import '@fontsource/bitter/700.css';

// A lazy route chunk can 404 when a deploy lands while a tab is open (old hashes
// are gone). Reload once to pick up the new build; the timestamp guard prevents
// a reload loop if the chunk is genuinely unavailable.
const CHUNK_RELOAD_KEY = 'chunkReloadAt';
const CHUNK_RELOAD_COOLDOWN_MS = 10000;
window.addEventListener('vite:preloadError', (event) => {
  try {
    const lastReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 0);
    if (Date.now() - lastReload < CHUNK_RELOAD_COOLDOWN_MS) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

let removeViewportFix: (() => void) | undefined;

const renderApp = () => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );
  root.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </React.StrictMode>,
  );
  reportWebVitals();
  // Pins the app to the visual viewport when the iOS keyboard opens.
  // Not installed at all outside iOS. Tear down any previous install first so
  // a re-render can't stack duplicate visualViewport listeners.
  removeViewportFix?.();
  removeViewportFix = installIosKeyboardViewportFix();
};

initializeI18n().then(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
